import styled from 'styled-components';

export const Canvas = styled.canvas<{ $size: number }>`
  display: block;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  pointer-events: none;
`;
